import { Link } from 'react-router-dom'
import { Shield, Clock, Phone, ChevronRight } from 'lucide-react'

// Logo e info agenzia
const AGENCY_LOGO = 'https://www.immosanremo.com/wp-content/uploads/2023/04/immo-sanremo-logo-23-footer.png'
const AGENCY_PHONE = '+39 0184 610689'

export function Header() {
  return (
    <header className="bg-white shadow-sm">
      {/* Top bar */}
      <div className="bg-gray-900 text-white text-sm py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center sm:justify-between items-center gap-4 flex-wrap">
            <div className="flex items-center gap-6">
              <span className="flex items-center gap-1">
                <Shield className="h-4 w-4" />
                Dati Reali Compravenduto
              </span>
              <span className="hidden sm:flex items-center gap-1">
                <Clock className="h-4 w-4" />
                Risultato in 2 minuti
              </span>
            </div>
            <a href={`tel:${AGENCY_PHONE}`} className="flex items-center gap-1 hover:text-primary-400 transition-colors">
              <Phone className="h-4 w-4" />
              <span>{AGENCY_PHONE}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-4">
            <img
              src={AGENCY_LOGO}
              alt="ImmoSanremo"
              className="h-14 w-auto"
            />
            <div className="hidden sm:block border-l border-gray-200 pl-4">
              <span className="text-lg font-semibold text-gray-700">
                Valutazione Immobili
              </span>
              <span className="block text-sm text-gray-500">
                Stima gratuita basata sul compravenduto
              </span>
            </div>
          </Link>
          <Link
            to="/valutazione"
            className="hidden sm:flex items-center gap-1.5 bg-accent-400 hover:bg-accent-500 text-gray-900 font-semibold text-sm px-5 py-2.5 rounded-xl transition-colors shadow-sm"
          >
            Valuta Ora
            <ChevronRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </header>
  )
}
